import { Star } from "lucide-react";

/**
 * A five-star row with `rating` of them filled.
 *
 * Shared rather than written per page: /lp and /thank-you show the same
 * reviews, and two star rows that round differently on the same review is the
 * kind of drift a visitor notices even when they cannot say what is wrong.
 */
const StarRow = ({
  rating,
  size = 14,
  className = "",
}: {
  rating: number;
  size?: number;
  className?: string;
}) => (
  <span
    className={`flex items-center gap-0.5 ${className}`}
    role="img"
    aria-label={`${rating} out of 5`}
  >
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={size}
        aria-hidden
        className={
          i < Math.round(rating) ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"
        }
      />
    ))}
  </span>
);

export default StarRow;
